// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2_QTw","productName":"Table_productName__3byGI"};